export default __webpack_public_path__ + "static/media/marketplace-sprite.56f7209b.png";